function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Always run this. Safari supports :focus-visible but often does not apply it on Tab.
focusVisiblePolyfill();

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    const code = (event.code || '').toUpperCase();
    const key = (event.key || '').toUpperCase();
    if (navKeys.includes(code) || navKeys.includes(key) || event.key === 'Tab' || event.key === ' ') {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  // Only pause product/media-related videos; keep homepage/header videos playing
  const videos = document.querySelectorAll('video');
  videos.forEach((video) => {
    const isHomeContext =
      video.closest('.template-index') ||
      video.closest('.header__video-logo') ||
      video.closest('.slideshow__media--video');
    const keepPlaying = video.hasAttribute('data-keep-playing') || video.dataset.keepPlaying === 'true';
    if (!isHomeContext && !keepPlaying) {
      video.pause();
    }
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.menu-drawer__menu-item.level-1):not(.menu-drawer__menu-item.level-2)').forEach((button) =>
    // this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.touchStartX = 0;
    this.touchEndX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].clientX;
    }, false);

    this.slider.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
    }, false);
  }

  handleSwipe() {
    const diffX = this.touchStartX - this.touchEndX;
    if (Math.abs(diffX) > 80) {
      if (diffX > 0) {
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.setSlidePosition(0);
        }
      } else {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          const lastSlidePosition = (this.sliderItemsToShow.length - 1) * this.sliderItemOffset;
          this.setSlidePosition(lastSlidePosition);
        }
      }
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const totalSlides = this.sliderItemsToShow.length;
    const lastSlidePosition = (totalSlides - 1) * this.sliderItemOffset;
  
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (event.currentTarget.name === 'next' && this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.slideScrollPosition = 0;
    }
    if (event.currentTarget.name === 'previous' && this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.slideScrollPosition = lastSlidePosition;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    //currentSlide.classList.add(`${animationClassOut}-${direction}`);
    //nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      //currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      //nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.backInStock();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateProductHeading();
      this.updateMedia();
      this.updateProductMediaAlt();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  backInStock() {
    const submitBtn = document.querySelector('.product-form__submit');
    const bisBtn = document.querySelector('.product-form__back-in-stock');

    if (submitBtn && submitBtn.getAttribute('data-coming-soon') === 'true') {
      submitBtn.classList.remove('hidden');
      if (bisBtn) bisBtn.classList.add('hidden');
      return;
    }

    console.log("Available: " + "" + this.currentVariant.available);
    if(JSON.stringify(this.currentVariant.available) === 'true') {
      if(submitBtn) {
        if(submitBtn.classList.contains('hidden')) {
          submitBtn.classList.remove('hidden');
        }
      }
      if(bisBtn) {
        if(!bisBtn.classList.contains('hidden')) {
          bisBtn.classList.add('hidden');
        }
      }
    } else {
      if(submitBtn) {
        if(!submitBtn.classList.contains('hidden')) {
          submitBtn.classList.add('hidden');
        }
      }
      if(bisBtn) {
        if(bisBtn.classList.contains('hidden')) {
          bisBtn.classList.remove('hidden');
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateProductMediaAlt() {
    if (!this.currentVariant) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    if (!mediaGalleries.length) return;

    const gallery = mediaGalleries[0];
    const productTitle = gallery.dataset.productTitle;
    if (!productTitle) return;

    const sizeOptionIndex = parseInt(gallery.dataset.sizeOptionIndex, 10);
    let altText = `${productTitle} product image`;

    if (!Number.isNaN(sizeOptionIndex) && sizeOptionIndex >= 0) {
      const sizeValue = this.currentVariant[`option${sizeOptionIndex + 1}`];
      if (sizeValue && sizeValue !== 'Default Title') {
        altText = `${productTitle} - ${sizeValue} product image`;
      }
    }

    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.querySelectorAll('img').forEach((image) => {
        image.alt = altText;
      });
    });

    const modal = document.querySelector(`#ProductModal-${this.dataset.section}`);
    if (modal) {
      modal.querySelectorAll('img').forEach((image) => {
        image.alt = altText;
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });

    // Start: Change product title according to selected variant
    this.updateProductHeading();
    // End: Change product title according to selected variant
  }

  updateProductHeading() {
    if (!this.currentVariant) return;

    const variantId = String(this.currentVariant.id);
    const inQuickAdd = Boolean(this.closest('quick-add-modal, .quick-add-modal'));
    const scope = inQuickAdd
      ? this.closest('quick-add-modal, .quick-add-modal')
      : this.closest('.shopify-section') || document;

    if (inQuickAdd) {
      const variantTitleElements = scope.querySelectorAll('.product__title .custom_variant_title');
      variantTitleElements.forEach((title) => {
        const parent = title.parentElement;
        const anchor = parent && parent.querySelector('a');
        if (!anchor) return;
        anchor.style.display = title.getAttribute('data-variant-id') === variantId ? 'block' : 'none';
      });
      return;
    }

    const headingName = scope.querySelector('.product__title .product-title__name');
    if (!headingName) return;

    const match = scope.querySelector(
      `.product__title .custom_variant_title[data-variant-id="${variantId}"]`
    );
    if (!match) return;

    const nextName = (match.getAttribute('data-variant-title') || match.textContent || '').trim();
    if (nextName) headingName.textContent = nextName;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (addButton.getAttribute('data-coming-soon') === 'true') {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = 'JOIN THE WAITLIST';
      return;
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          const productRecommendationsSlider = this.querySelector('[data-products-recommendations-slider]');
            if (productRecommendationsSlider && typeof Swiper !== 'undefined') {
              if (productRecommendationsSlider.swiper) {
                productRecommendationsSlider.swiper.destroy(true, true);
              }

              const isMobile = window.matchMedia('(max-width: 767px)').matches;

              new Swiper(productRecommendationsSlider, {
                loop: false,
                autoHeight: true,
                draggable: true,
                slidesPerView: 4,
                centeredSlides: false,
                a11y: true,
                spaceBetween: 10,
                freeMode: true,
                keyboard: {
                  enabled: true,
                  onlyInViewport: true
                },
                grabCursor: true,
                breakpoints: {
                  300: {
                    spaceBetween: 10,
                    slidesPerView: 2,
                    loop: false,
                    centeredSlides: false
                  },
                  768: {
                    spaceBetween: 10,
                    slidesPerView: 3,
                    centeredSlides: false,
                    loop: false
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                    loop: false
                  }
                },
                navigation: {
                  nextEl: productRecommendationsSlider.querySelector('.swiper-button-next'),
                  prevEl: productRecommendationsSlider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                  el: productRecommendationsSlider.querySelector('.swiper-pagination'),
                  clickable: true,
                  dynamicBullets: isMobile,
                  dynamicMainBullets: 7
                },
              });
            }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// const videoElement = document.querySelector(".product-media-container [data-video-play]");
// videoElement?.click();

// Start: Product page video customizations
document.addEventListener('DOMContentLoaded', function() {
  var playButton = document.querySelector('.product__modal-opener--video .product__media-toggle');
  var closeButton = document.querySelector('.product-media-modal__toggle');
  var modalVideo = document.querySelector('.product-media-modal .deferred-media video');
  var sliderVideo = document.querySelector('.slider-mobile-gutter .deferred-media video');

  if (playButton && modalVideo) {
    playButton.addEventListener('click', function() {
      modalVideo.play().catch(error => {
        console.error('Error trying to play the video:', error);
      });
    });
  }
  if (closeButton && sliderVideo) {
    closeButton.addEventListener('click', function() {
      sliderVideo.play().catch(error => {
        console.error('Error trying to play the video:', error);
      });
    });
  }
});
// End: Product page video customizations

const menuMobileFooter = document.querySelectorAll(".footer-block--menu");
// Iterar sobre cada botón y agregar evento click
menuMobileFooter?.forEach(function(menuMobile) {
  menuMobile.addEventListener("click", function() {
    menuMobile.classList.toggle("open");
  });
});

// window.addEventListener('DOMContentLoaded', () => {
//   setTimeout(() => {
//     let elemento = document.querySelectorAll(".kl_reviews__star_rating_widget__label");
//     // Iterar sobre cada botón y agregar evento click
//     elemento?.forEach(function(elementoTexto) {
//       let texto = elementoTexto.textContent.replace(' rating', '').replace('s', '');
//       elementoTexto.textContent = `(${texto})`;
//     });
//   }, 3000);
// });

// Start: Product page slider customizations
document.addEventListener('DOMContentLoaded', function() {
  const zoomButtons = document.querySelectorAll('.product__media-toggle');
  zoomButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const activeImg = document.querySelector('.product-media-modal__content img.active');
      const activeVideo = document.querySelector('.product-media-modal__content .deferred-media.active');

      if (activeImg) {
        addTouchListeners(activeImg);
      }

      if (activeVideo) {
        addTouchListeners(activeVideo);
      }

      function addTouchListeners(element) {
        let touchstartX = 0;
        let touchendX = 0;

        element.addEventListener('touchstart', function(event) {
          touchstartX = event.changedTouches[0].screenX;
        }, false);

        element.addEventListener('touchend', function(event) {
          touchendX = event.changedTouches[0].screenX;
          handleSwipeGesture();
        }, false);

        function handleSwipeGesture() {
          if (touchendX < touchstartX || touchendX > touchstartX) {
            const toggleButton = document.querySelector('.product-media-modal__toggle');
            if (toggleButton) {
              toggleButton.click();
            }
          }
        }
      }
    });
  });
});
// End: Product page slider customizations


//Start: GWP
const isCustomGWPEnabled = document.querySelector('.gwp-data')?.getAttribute('data-enable-custom-gwp');
const gwpVariant = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id');
const gwpVariant2 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id-2');
const gwpVariant3 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id-3');
const gwpVariant4 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id-4');
const gwpVariant5 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id-5');
const gwpVariant6 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-variant-id-6');

const gwpEnableOnThreshold = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-order-threshold');

const gwpEnableOnProduct = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-product');
const gwpEnableOnProduct2 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-product-2');
const gwpEnableOnProduct3 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-product-3');
const gwpEnableOnProduct4 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-product-4');
const gwpEnableOnProduct5 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-enable-on-product-5');

// Variant restriction for single-product rules
const gwpRestrictVariants = document.querySelector('.gwp-data')?.getAttribute('data-gwp-restrict-variants');
const gwpRestrictVariants2 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-restrict-variants-2');
const gwpRestrictVariants3 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-restrict-variants-3');
const gwpRestrictVariants4 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-restrict-variants-4');
const gwpRestrictVariants5 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-restrict-variants-5');

function parseJsonAttr(attr) { try { return attr ? JSON.parse(attr) : []; } catch(e) { return []; } }
const gwpBuyVariants = parseJsonAttr(document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-variants'));
const gwpBuyVariants2 = parseJsonAttr(document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-variants-2'));
const gwpBuyVariants3 = parseJsonAttr(document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-variants-3'));
const gwpBuyVariants4 = parseJsonAttr(document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-variants-4'));
const gwpBuyVariants5 = parseJsonAttr(document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-variants-5'));

const isBYOBGiftEnabled = document.querySelector('.gwp-data')?.getAttribute('data-enable-byob-gift');
const byobBuyVariant = document.querySelector('.gwp-data')?.getAttribute('data-byob-buy-product');
const byobGiftVariant = document.querySelector('.gwp-data')?.getAttribute('data-byob-gift-product');

// GWP runtime controls
const GWP_DEBUG = false;
function gwpLog() { if (GWP_DEBUG) { try { console.log.apply(console, arguments); } catch(e) {} } }
let gwpAddInFlight = new Set();
let gwpRemoveInFlight = new Set();
let gwpEvaluateInProgress = false;
let gwpEvaluateQueued = false;
let gwpRefreshDrawerInFlight = false;
let gwpRefreshMainInFlight = false;
let gwpRefreshBubbleInFlight = false;
let gwpLastCartItemCount = 0;

// Fail-safe: gift variants that must never be (re-)added.
// Seeded from theme.liquid with any gift whose variant is sold out at render time,
// then extended at runtime whenever /cart/add.js rejects a gift as unavailable.
const GWP_MAX_ADD_ATTEMPTS = 3;
let gwpAddAttempts = new Map();
let gwpUnavailableVariants = new Set(
  (document.querySelector('.gwp-data')?.getAttribute('data-gwp-unavailable-variants') || '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean)
);

function setCartDrawerCheckoutDisabled(disabled) {
  const button = document.querySelector('#CartDrawer-Checkout');
  const drawer = document.querySelector('cart-drawer');
  if (!button) return;

  if (disabled || drawer?.classList.contains('is-empty')) {
    button.classList.add('btn-disabled');
    button.setAttribute('disabled', 'true');
  } else {
    button.classList.remove('btn-disabled');
    button.removeAttribute('disabled');
  }
}

function refreshCartIconBubble() {
  if (gwpRefreshBubbleInFlight) return;
  gwpRefreshBubbleInFlight = true;
  try { setCartIconBubbleCount(gwpLastCartItemCount); } catch(e) {}
  gwpRefreshBubbleInFlight = false;
}

function setCartIconBubbleCount(count) {
  const anchor = document.getElementById('cart-icon-bubble');
  if (!anchor) return;
  let bubble = anchor.querySelector('.cart-count-bubble');
  if (count > 0) {
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const spanVisible = document.createElement('span');
      spanVisible.setAttribute('aria-hidden', 'true');
      const spanSR = document.createElement('span');
      spanSR.className = 'visually-hidden';
      bubble.appendChild(spanVisible);
      bubble.appendChild(spanSR);
      anchor.appendChild(bubble);
    }
    const visible = bubble.querySelector('span[aria-hidden="true"]');
    const sr = bubble.querySelector('.visually-hidden');
    if (visible) visible.textContent = String(count);
    if (sr) sr.textContent = `${count} item${count === 1 ? '' : 's'}`;
  } else if (bubble) {
    bubble.remove();
  }
}

// New: Always-on sitewide gift
const gwpEnableAlways = document.querySelector('.gwp-data')?.querySelector('[data-gwp-enable-always]')?.getAttribute('data-gwp-enable-always');
const gwpVariantAlways = document.querySelector('.gwp-data')?.querySelector('[data-gwp-variant-id-always]')?.getAttribute('data-gwp-variant-id-always');

// New: Multi-product trigger gift
const gwpEnableOnProductList = document.querySelector('.gwp-data')?.querySelector('[data-gwp-enable-on-product-list]')?.getAttribute('data-gwp-enable-on-product-list');
const gwpVariantMulti = document.querySelector('.gwp-data')?.querySelector('[data-gwp-variant-id-multi]')?.getAttribute('data-gwp-variant-id-multi');
let gwpBuyProductList = [];
try {
  const listAttr = document.querySelector('.gwp-data')?.querySelector('[data-gwp-buy-product-list]')?.getAttribute('data-gwp-buy-product-list');
  if (listAttr) {
    gwpBuyProductList = JSON.parse(listAttr).map(p => String(p.id));
  }
} catch (e) {
  console.warn('Failed to parse data-gwp-buy-product-list', e);
}
// Multi-product rule does not use variant-level restrictions

// New: Members gift — product list + optional customer tag + optional country.
// Written by snippets/le-gwp-data.liquid, which owns the eligibility rules.
//
// The variant id is ALWAYS present when the promo has a gift product configured; only the
// `enable` attribute reflects eligibility. That is deliberate — a rule with no variant id is
// skipped entirely below (`if (!variant) return`), which would mean an ineligible visitor's
// gift is never REMOVED from their cart. Keeping the id here means ineligibility resolves to
// removal, and keeps the gift out of nonGiftSubtotal so it can't help earn a threshold GWP.
const gwpMembersEnable = document.querySelector('.gwp-data')?.querySelector('[data-gwp-members]')?.getAttribute('data-gwp-members-enable');
const gwpMembersVariant = document.querySelector('.gwp-data')?.querySelector('[data-gwp-members]')?.getAttribute('data-gwp-members-variant-id');
const gwpMembersMessage = document.querySelector('.gwp-data')?.querySelector('[data-gwp-members]')?.getAttribute('data-gwp-members-message');
let gwpMembersBuyProductList = [];
try {
  const membersListAttr = document.querySelector('.gwp-data')?.querySelector('[data-gwp-members]')?.getAttribute('data-gwp-members-buy-product-list');
  if (membersListAttr) {
    gwpMembersBuyProductList = JSON.parse(membersListAttr).map(p => String(p.id));
  }
} catch (e) {
  console.warn('Failed to parse data-gwp-members-buy-product-list', e);
}

function applyStylesToCartItems(variantId) {
  const gwpRowBgColor = document.querySelector('.gwp-data')?.getAttribute('data-gwp-row-bg-color');
  const gwpRowTextColor = document.querySelector('.gwp-data')?.getAttribute('data-gwp-row-text-color');
  const gwpRowMessage = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message');
  const gwpRowMessage2 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message-2');
  const gwpRowMessage3 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message-3');
  const gwpRowMessage4 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message-4');
  const gwpRowMessage5 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message-5');
  const gwpRowMessage6 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-message-6');
  const gwpByobMessage = document.querySelector('.gwp-data')?.getAttribute('data-byob-message');
  const gwpRowMessageAlways = document.querySelector('.gwp-data')?.querySelector('[data-gwp-message-always]')?.getAttribute('data-gwp-message-always');
  const gwpRowMessageMulti = document.querySelector('.gwp-data')?.querySelector('[data-gwp-message-multi]')?.getAttribute('data-gwp-message-multi');

  const cartItemSelectors = document.querySelectorAll(
    `#CartDrawer-CartItems .cart-item[data-variant-id="${variantId}"], 
     #main-cart-items .cart-item[data-variant-id="${variantId}"]`
  );

  if (cartItemSelectors.length === 0) {
    gwpLog("No cart items found for variantId:", variantId);
    return;
  }

  cartItemSelectors.forEach((cartItemSelector) => {
    const cartItemDetails = cartItemSelector.querySelector('.cart-item__details');

    if (gwpRowBgColor) {
      cartItemSelector.style.backgroundColor = gwpRowBgColor;
    }

    if (gwpRowTextColor) {
      cartItemSelector.querySelectorAll('*').forEach(element => element.style.color = gwpRowTextColor);
    }

    cartItemSelector.classList.add('free-gift-item');

    const quantityPopoverContainer = cartItemSelector.querySelector('.cart-item__quantity .quantity-popover-container');
    if (quantityPopoverContainer) quantityPopoverContainer.style.visibility = 'hidden';

    const cartRemoveButton = cartItemSelector.querySelector('cart-remove-button');
    if (cartRemoveButton) cartRemoveButton.querySelectorAll('*').forEach(child => child.style.visibility = 'hidden');

    cartItemSelector.querySelectorAll('.price').forEach(price => price.textContent = 'FREE');

    if (!cartItemDetails) {
      console.error("cart-item__details element not found for variantId:", variantId);
      return;
    }

    function handleGwpRowMessage(variantCheck, message) {
      if (message && variantId === variantCheck) {
        cartItemSelector.querySelectorAll('.product-option').forEach(option => {
          if (!option.classList.contains('selected-product-option')) {
            option.remove();
          }
          if (option.classList.contains('selected-product-option')) {
            option.classList.add('free-gift-item-selected-option');
            const dtElement = option.querySelector('dt');
            if (dtElement) {
              dtElement.remove();
            }
          }
        });

        const existingMessage = cartItemDetails.querySelector('.first-to-try-message');
        if (!existingMessage) {
          const newElement = document.createElement('p');
          newElement.textContent = message;
          newElement.classList.add('first-to-try-message');
          cartItemDetails.appendChild(newElement);
        }
      }
    }

    handleGwpRowMessage(gwpVariant, gwpRowMessage);
    handleGwpRowMessage(gwpVariant2, gwpRowMessage2);
    handleGwpRowMessage(gwpVariant3, gwpRowMessage3);
    handleGwpRowMessage(gwpVariant4, gwpRowMessage4);
    handleGwpRowMessage(gwpVariant5, gwpRowMessage5);
    handleGwpRowMessage(gwpVariant6, gwpRowMessage6);
    handleGwpRowMessage(byobGiftVariant, gwpByobMessage);
    handleGwpRowMessage(gwpVariantAlways, gwpRowMessageAlways);
    handleGwpRowMessage(gwpVariantMulti, gwpRowMessageMulti);
    handleGwpRowMessage(gwpMembersVariant, gwpMembersMessage);
  });
}


function handleCartLogic() {
  if (gwpEvaluateInProgress) {
    gwpEvaluateQueued = true;
    return;
  }
  const gwpThreshold = document.querySelector('.gwp-data')?.getAttribute('data-gwp-order-threshold');
  const gwpBuyProduct = document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-product');
  const gwpBuyProduct2 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-product-2');
  const gwpBuyProduct3 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-product-3');
  const gwpBuyProduct4 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-product-4');
  const gwpBuyProduct5 = document.querySelector('.gwp-data')?.getAttribute('data-gwp-buy-product-5');

  const gwpLoadingText = document.querySelector('.gwp-data')?.getAttribute('data-gwp-loading-text');
  const hideLoadingText = document.querySelector('.gwp-data')?.getAttribute('data-gwp-hide-loading-text');
  const cartFormElement = document.querySelector('#cart');

  let cartThreshold;
  if (gwpThreshold) {
    cartThreshold = parseInt(gwpThreshold) * 100;
  }

  function addProductToCart(variantId, quantity = 1, force = false, skipLocalStorage = false) {
    const variantKey = String(variantId);
    // Never retry a gift already known to be unavailable.
    if (gwpUnavailableVariants.has(variantKey)) {
      return;
    }
    if (gwpAddInFlight.has(variantKey)) {
      return;
    }
    if (!force && localStorage.getItem(`productYAdded_${variantId}`)) {
      return;
    }

    // Circuit breaker: a gift that never reaches the cart (sold out, deleted, or
    // stripped by an app) must not be retried indefinitely.
    const addAttempts = (gwpAddAttempts.get(variantKey) || 0) + 1;
    gwpAddAttempts.set(variantKey, addAttempts);
    if (addAttempts > GWP_MAX_ADD_ATTEMPTS) {
      gwpUnavailableVariants.add(variantKey);
      console.warn(`GWP ${variantKey} did not reach the cart after ${GWP_MAX_ADD_ATTEMPTS} attempts; skipping it for this session.`);
      return;
    }

    gwpAddInFlight.add(variantKey);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: { _gwp: true }
      })
    })
    .then(response => {
      // 422 (sold out / not purchasable) and 404 (variant no longer exists) can never
      // succeed on retry, so block this gift for the rest of the session.
      if (response.status === 422 || response.status === 404) {
        gwpUnavailableVariants.add(variantKey);
        console.error(`GWP ${variantKey} is unavailable (HTTP ${response.status}) and will not be added to the cart.`);
        return null;
      }
      if (!response.ok) {
        // Transient failure (429/5xx): fail this attempt without blocking the gift.
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // A failed add must not fall through to the success path. Doing so marked the
      // gift as added and re-triggered handleCartLogic, which re-attempted the same
      // failing add every 500ms indefinitely.
      if (!data) {
        return;
      }
      gwpLog(`Successfully added product ${variantId} to cart`);
      if (!skipLocalStorage) {
        localStorage.setItem(`productYAdded_${variantId}`, 'true'); // ✅ Updated to localStorage
      }
      refreshCartForm(variantId);
      if (cartFormElement) {
        refreshMainCartForm(variantId);
      }
      refreshCartIconBubble();
      // Re-evaluate rules after add completes to catch parallel additions
      setTimeout(() => { try { handleCartLogic(); } catch(e) {} }, 500);
    })
    .catch(error => {
      gwpLog('Error adding product to cart:', error);
    })
    .finally(() => {
      gwpAddInFlight.delete(variantKey);
    });
  }

  function removeProductFromCart(variantId) {
    if (gwpRemoveInFlight.has(String(variantId))) {
      return;
    }
    gwpRemoveInFlight.add(String(variantId));
    gwpLog(`Removing product ${variantId} from cart`);
  
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      gwpLog(`Successfully removed product ${variantId} from cart`);
      localStorage.removeItem(`productYAdded_${variantId}`); // ✅ Updated to localStorage
      refreshCartForm(variantId);
      if (cartFormElement) {
        refreshMainCartForm(variantId);
      }
      refreshCartIconBubble();
      // Re-evaluate rules after remove completes to ensure threshold/always-on GWPs update immediately
      setTimeout(() => { try { handleCartLogic(); } catch(e) {} }, 400);
    })
    .catch(error => {
      gwpLog('Error removing product from cart:', error);
    })
    .finally(() => {
      gwpRemoveInFlight.delete(String(variantId));
    });
  }


  function refreshCartForm(variantId) {
    console.log(`Refreshing cart for variantId: ${variantId}`);

    const cartFormElement = document.querySelector('#CartDrawer-Form');
    if (!cartFormElement) {
      console.error('Cart form element not found.');
      return;
    }
    if (gwpRefreshDrawerInFlight) {
      return;
    }
    gwpRefreshDrawerInFlight = true;

    // Disable checkout only while this refresh is in flight, so the GWP is
    // added before the user can check out. Re-enabled in .finally() below.
    setCartDrawerCheckoutDisabled(true);

    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart data: ${response.status}`);
        }
        return response.text();
      })
      .then((cartHTML) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartHTML, 'text/html');
        const localDrawer = document.querySelector('cart-drawer');
        const incomingDrawer = doc.querySelector('cart-drawer');
        if (!localDrawer || !incomingDrawer) {
          console.error('Could not update cart drawer content from fetched HTML.');
          return;
        }

        let replaced = false;
        ['cart-drawer-items', '.drawer__footer'].forEach((selector) => {
          const target = localDrawer.querySelector(selector);
          const source = incomingDrawer.querySelector(selector);
          if (target && source) {
            target.replaceWith(source);
            replaced = true;
          }
        });

        const drawerIsEmpty = incomingDrawer.classList.contains('is-empty');
        localDrawer.classList.toggle('is-empty', drawerIsEmpty);
        if (typeof window.syncCartDrawerCheckoutEmptyState === 'function') {
          window.syncCartDrawerCheckoutEmptyState(drawerIsEmpty);
        }
        // Sync empty-state markup (.drawer__inner-empty)
        const incomingEmpty = incomingDrawer.querySelector('.drawer__inner-empty');
        const localInner = localDrawer.querySelector('.drawer__inner');
        const localEmpty = localInner ? localInner.querySelector('.drawer__inner-empty') : null;
        if (incomingEmpty && localInner) {
          if (localEmpty) {
            localEmpty.replaceWith(incomingEmpty);
          } else {
            // Insert before cart contents so it appears at the top
            const anchor = localInner.querySelector('cart-drawer-items') || localInner.firstElementChild;
            if (anchor && anchor.parentNode) {
              anchor.parentNode.insertBefore(incomingEmpty, anchor);
            } else {
              localInner.appendChild(incomingEmpty);
            }
          }
        } else if (!incomingEmpty && localEmpty) {
          // Remove stale empty-state if server says not empty
          localEmpty.remove();
        }

        // Fallback: replace form innerHTML if selectors not found
        if (!replaced) {
          const newCartForm = doc.querySelector('#CartDrawer-Form');
          if (newCartForm) {
            cartFormElement.innerHTML = newCartForm.innerHTML;
            replaced = true;
          }
        }

        if (replaced) {
          gwpLog('Cart Drawer updated');
          if (variantId) {
            applyStylesToCartItems(variantId);
          }
          if (typeof window.initCartDrawerPromoDiscount === 'function') {
            window.initCartDrawerPromoDiscount();
          }
          if (typeof window.initCartDrawerBundleDetails === 'function') {
            window.initCartDrawerBundleDetails();
          }
          if (typeof window.initCartDrawerExpressCheckout === 'function') {
            window.initCartDrawerExpressCheckout();
          }
        } else {
          console.error('Could not update cart drawer content from fetched HTML.');
        }
      })
      .catch((error) => {
        console.error('Error refreshing the cart:', error);
      })
      .finally(() => {
        gwpRefreshDrawerInFlight = false;
        // Re-enable the live checkout button after the footer refresh completes.
        setCartDrawerCheckoutDisabled(false);
      });
  }

  function refreshMainCartForm(variantId) {
    console.log(`Refreshing main cart for variantId: ${variantId}`);

    if (!cartFormElement) {
      console.error('Cart form element not found.');
      return;
    }
    if (gwpRefreshMainInFlight) {
      return;
    }
    gwpRefreshMainInFlight = true;

    // Disable checkout only while this refresh is in flight; re-enabled in .finally() below.
    const mainCheckoutButton = document.querySelector('#checkout');
    if (mainCheckoutButton) {
      mainCheckoutButton.classList.add('btn-disabled');
      mainCheckoutButton.setAttribute('disabled', 'true');
    }

    fetch('/cart?view=main')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart data: ${response.status}`);
        }
        return response.text(); 
      })
      .then((cartHTML) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartHTML, 'text/html');
        const newCartForm = doc.querySelector('#cart');

        if (newCartForm) {
          cartFormElement.innerHTML = newCartForm.innerHTML;
          gwpLog("Main cart updated with new items");
          applyStylesToCartItems(variantId);
        } else {
          console.error('New cart form not found in the fetched HTML.');
        }
      })
      .catch((error) => {
        console.error('Error refreshing the cart:', error);
      })
      .finally(() => {
        gwpRefreshMainInFlight = false;
        const liveMainCheckoutButton = document.querySelector('#checkout');
        if (liveMainCheckoutButton) {
          liveMainCheckoutButton.classList.remove('btn-disabled');
          liveMainCheckoutButton.removeAttribute('disabled');
        }
      });
  }

  // Logic for gwpVariant
  function showPopup() {
    // Only show when cart drawer is open
    const cartDrawerEl = document.querySelector('cart-drawer');
    const isDrawerOpen = cartDrawerEl && (cartDrawerEl.hasAttribute('open') || cartDrawerEl.classList.contains('active') || cartDrawerEl.classList.contains('is-open'));
    if (!isDrawerOpen) {
      return null;
    }

    var drawerInner = document.querySelector('.drawer__inner');
    if (hideLoadingText === 'true') {
      return null;
    }

    if (!drawerInner) {
      console.error("'drawer__inner' element not found.");
      return;
    }

    var overlay = document.createElement('div');
    overlay.style.position = 'absolute';
    overlay.style.top = 0;
    overlay.style.left = 0;
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.zIndex = '999';

    var popup = document.createElement('div');
    popup.style.position = 'absolute';
    popup.style.left = '50%';
    popup.style.top = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.backgroundColor = 'white';
    popup.style.padding = '20px';
    popup.style.borderRadius = '5px';
    popup.style.boxShadow = '0 0 15px rgba(0, 0, 0, 0.3)';
    popup.style.zIndex = '1000';

    var popupText = document.createElement('p');
    popupText.innerText = gwpLoadingText;
    popup.appendChild(popupText);

    drawerInner.appendChild(overlay);
    drawerInner.appendChild(popup);

    setTimeout(function() {
        hidePopup(overlay, popup);
    }, 2000);
  }

  function hidePopup(overlay, popup) {
    overlay.remove();
    popup.remove();
  }

  
const gwpVariants = [
  // Threshold rule
  { variant: gwpVariant, type: 'threshold', threshold: gwpThreshold, enableOn: gwpEnableOnThreshold },
  // Single-product rules
  { variant: gwpVariant2, type: 'single', buyProducts: gwpBuyProduct ? [String(gwpBuyProduct)] : [], buyVariants: gwpBuyVariants, restrictByVariant: gwpRestrictVariants, enableOn: gwpEnableOnProduct },
  { variant: gwpVariant3, type: 'single', buyProducts: gwpBuyProduct2 ? [String(gwpBuyProduct2)] : [], buyVariants: gwpBuyVariants2, restrictByVariant: gwpRestrictVariants2, enableOn: gwpEnableOnProduct2 },
  { variant: gwpVariant4, type: 'single', buyProducts: gwpBuyProduct3 ? [String(gwpBuyProduct3)] : [], buyVariants: gwpBuyVariants3, restrictByVariant: gwpRestrictVariants3, enableOn: gwpEnableOnProduct3 },
  { variant: gwpVariant5, type: 'single', buyProducts: gwpBuyProduct4 ? [String(gwpBuyProduct4)] : [], buyVariants: gwpBuyVariants4, restrictByVariant: gwpRestrictVariants4, enableOn: gwpEnableOnProduct4 },
  { variant: gwpVariant6, type: 'single', buyProducts: gwpBuyProduct5 ? [String(gwpBuyProduct5)] : [], buyVariants: gwpBuyVariants5, restrictByVariant: gwpRestrictVariants5, enableOn: gwpEnableOnProduct5 },
  // BYOB rule
  { variant: byobGiftVariant, type: 'single', buyProducts: byobBuyVariant ? [String(byobBuyVariant)] : [], enableOn: isBYOBGiftEnabled },
  // Always-on rule
  { variant: gwpVariantAlways, type: 'always', enableOn: gwpEnableAlways },
  // Multi-product rule
  { variant: gwpVariantMulti, type: 'multi', buyProducts: gwpBuyProductList, enableOn: gwpEnableOnProductList },
  // Members rule — same product-level matching as 'multi'; the customer tag and country are
  // resolved in Liquid and arrive already folded into enableOn.
  { variant: gwpMembersVariant, type: 'multi', buyProducts: gwpMembersBuyProductList, enableOn: gwpMembersEnable },
];

fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    gwpEvaluateInProgress = true;
    gwpLog("Cart data fetched successfully:", cart);
    // Update header bubble immediately based on live cart data
    try {
      gwpLastCartItemCount = cart.item_count || 0;
      setCartIconBubbleCount(gwpLastCartItemCount);
    } catch(e) {}

    // Any gift that actually reached the cart succeeded, so clear its failure count.
    cart.items.forEach(item => gwpAddAttempts.delete(String(item.variant_id)));

    const gwpToAdd = new Set();
    const gwpToRemove = new Set();
    const addedGwpMap = new Map(); // Tracks which GWPs should be added (prevents duplicates)

    // Compute whether cart has any non-gift items
    const allGiftVariantSet = new Set(
      gwpVariants
        .map(r => r.variant)
        .filter(Boolean)
        .map(v => String(v))
    );
    const hasNonGiftInCart = cart.items.some(item => !allGiftVariantSet.has(String(item.variant_id)));

    // Compute subtotal of only non-gift items (in cents)
    let nonGiftSubtotal = 0;
    cart.items.forEach(item => {
      if (!allGiftVariantSet.has(String(item.variant_id))) {
        nonGiftSubtotal += (item.line_price || 0);
      }
    });

    gwpVariants.forEach(({ variant, type, threshold, buyProducts = [], buyVariants = [], restrictByVariant, enableOn }) => {
      if (!variant) return;

      gwpLog(`Processing GWP Variant: ${variant}`);

      const productYInCart = cart.items.some(item => item.variant_id == variant);
      const isCartTotalAboveThreshold = type === 'threshold' && threshold ? nonGiftSubtotal >= parseInt(threshold) * 100 : false;
      let gwpBuyProductInCart = false;
      if (type === 'single' || type === 'multi') {
        const productMatch = buyProducts.length > 0 && cart.items.some(item => buyProducts.includes(String(item.product_id)));
        if (type === 'multi') {
          gwpBuyProductInCart = productMatch; // multi-product uses product-level only
        } else {
          const variantMatch = restrictByVariant && buyVariants.length > 0 && cart.items.some(item => buyVariants.includes(String(item.variant_id)));
          gwpBuyProductInCart = (restrictByVariant ? variantMatch : productMatch);
        }
      }

      gwpLog(`Product in cart: ${productYInCart}, Threshold Met: ${isCartTotalAboveThreshold}, Buy Product Found: ${gwpBuyProductInCart}`);

      const eligible = !!enableOn && ((type === 'always' ? hasNonGiftInCart : false) || isCartTotalAboveThreshold || gwpBuyProductInCart);
      if (eligible) {
        if (!addedGwpMap.has(variant)) {
          gwpToAdd.add(variant);
          addedGwpMap.set(variant, true);
        }
      } else {
        gwpToRemove.add(variant);
      }
    });

    // Prevent removing items that should still be added
    gwpToRemove.forEach(variant => {
      if (gwpToAdd.has(variant)) {
        gwpLog(`Skipping removal of ${variant}, as it's still required.`);
        gwpToRemove.delete(variant);
      }
    });

    gwpLog("Final GWP Variants to Add:", Array.from(gwpToAdd));
    gwpLog("Final GWP Variants to Remove:", Array.from(gwpToRemove));

    // Add GWPs if not already in cart
    gwpToAdd.forEach(variant => {
      if (gwpUnavailableVariants.has(String(variant))) {
        gwpLog(`Skipping unavailable free item ${variant}.`);
        return;
      }
      if (!cart.items.some(item => item.variant_id == variant) && !gwpAddInFlight.has(String(variant))) {
        gwpLog(`Adding free item ${variant} to cart...`);
        showPopup();
        const bypass = true; // ensure parallel adds are not blocked by localStorage
        addProductToCart(variant, 1, bypass, bypass);
      }
    });

    // Enforce max quantity of 1 for all GWP variants — prevents API-level quantity manipulation
    gwpVariants.forEach(({ variant }) => {
      if (!variant) return;
      const cartItem = cart.items.find(item => item.variant_id == variant);
      if (cartItem && cartItem.quantity > 1) {
        gwpLog(`GWP ${variant} has quantity ${cartItem.quantity}, capping to 1`);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: String(variant), quantity: 1 })
        }).then(() => refreshCartForm(variant));
      }
    });

    // Remove GWPs only if their own rule is not eligible anymore
    gwpToRemove.forEach(variant => {
      // Only remove if this specific rule's trigger is not present
      const rule = gwpVariants.find(r => r.variant == variant);
      if (!rule) return;

      const { type, threshold, buyProducts = [], buyVariants = [], restrictByVariant, enableOn } = rule;

      let stillEligible = !!enableOn && ((type === 'always' && hasNonGiftInCart)
        || (type === 'threshold' && threshold && nonGiftSubtotal >= parseInt(threshold) * 100));
      if (!stillEligible && (type === 'single' || type === 'multi')) {
        const productMatch = buyProducts.length > 0 && cart.items.some(item => buyProducts.includes(String(item.product_id)));
        if (type === 'multi') {
          stillEligible = productMatch;
        } else {
          const variantMatch = restrictByVariant && buyVariants.length > 0 && cart.items.some(item => buyVariants.includes(String(item.variant_id)));
          stillEligible = restrictByVariant ? variantMatch : productMatch;
        }
      }

      if (!stillEligible && cart.items.some(item => item.variant_id == variant) && !gwpRemoveInFlight.has(String(variant))) {
        gwpLog(`Removing free item ${variant} from cart...`);
        showPopup();
        removeProductFromCart(variant);
        localStorage.removeItem(`productYAdded_${variant}`);

      }
    });

    // Safety: If cart contains only gifts, remove them and hard refresh to sync UI
    if (!hasNonGiftInCart && cart.items.length > 0) {
      let removedAnyGift = false;
      cart.items.forEach(item => {
        if (allGiftVariantSet.has(String(item.variant_id))) {
          gwpLog(`Removing lone gift ${item.variant_id} from cart...`);
          removedAnyGift = true;
          removeProductFromCart(String(item.variant_id));
          localStorage.removeItem(`productYAdded_${String(item.variant_id)}`);
        }
      });
      if (removedAnyGift) {
        setTimeout(() => {
          try { handleCartLogic(); } catch(e) {}
        }, 300);
      }
    }

    // Apply styles after adding
    gwpToAdd.forEach(variant => {
      setTimeout(() => {
        applyStylesToCartItems(variant);
      }, 500);
    });

  })
  .catch(error => console.error("Error fetching cart data:", error))
  .finally(() => {
    gwpEvaluateInProgress = false;
    if (gwpEvaluateQueued) {
      gwpEvaluateQueued = false;
      setTimeout(() => handleCartLogic(), 100);
    }
  });


}


document.addEventListener('DOMContentLoaded', function () {
  if (isCustomGWPEnabled) {
    handleCartLogic();

    const gwpVariants = [
      { enable: gwpEnableOnThreshold, variant: gwpVariant },
      { enable: gwpEnableOnProduct, variant: gwpVariant2 },
      { enable: gwpEnableOnProduct2, variant: gwpVariant3 },
      { enable: gwpEnableOnProduct3, variant: gwpVariant4 },
      { enable: gwpEnableOnProduct4, variant: gwpVariant5 },
      { enable: gwpEnableOnProduct5, variant: gwpVariant6 },
      { enable: isBYOBGiftEnabled, variant: byobGiftVariant },
      { enable: gwpEnableAlways, variant: gwpVariantAlways },
      { enable: gwpEnableOnProductList, variant: gwpVariantMulti },
      // NOTE: this array SHADOWS the module-level gwpVariants above. It exists only to drive
      // applyStylesToCartItems — miss an entry here and the gift still adds correctly but
      // renders as a normal priced, removable line item instead of a locked FREE row.
      { enable: gwpMembersEnable, variant: gwpMembersVariant },
    ];

    gwpVariants.forEach(({ enable, variant }, index) => {
      if (enable && variant) {
        applyStylesToCartItems(variant);
      }
    });

    document.addEventListener('click', function (event) {
      let target = event.target;

      if (target.tagName.toLowerCase() === 'svg' || target.tagName.toLowerCase() === 'path') {
        target = target.closest('a, button, cart-remove-button');
      }

      if (target && (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'cart-remove-button')) {
        const parentClasses = ['cart-items', 'product-form__buttons', 'cart-drawer', 'product-grid'];
        const isInSpecifiedElement = parentClasses.some(cls => target.closest(`.${cls}`));

        if (isInSpecifiedElement) {
          setTimeout(() => {
            handleCartLogic();
          }, 1000);
        }
      }
    });

    // Re-evaluate on cart updates from core cart scripts
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          setTimeout(() => {
            handleCartLogic();
          }, 300);
        });
      }
    } catch (e) {}

    // Re-evaluate on history restore (e.g., browser back/forward cache)
    window.addEventListener('pageshow', () => {
      setTimeout(() => {
        handleCartLogic();
      }, 300);
    });

    // Discount code field listener
    setTimeout(() => {
      const scDiscountApp = document.getElementById('scDiscountApp');
      if (scDiscountApp) {
        const observer = new MutationObserver(() => {
          const discountSubmitButton = document.getElementById('sc-discount__submit');

          if (discountSubmitButton) {
            setTimeout(() => {
              handleCartLogic();
            }, 2000);
          }
        });

        observer.observe(scDiscountApp, { childList: true, subtree: true });
      } else {
        console.log("No Discount App found.");
      }
    }, 1000);
  } else {
    console.log("Custom GWP is disabled.");
  }
});
//End: GWP